import WheatTortillaProduct from 'models/WheatTortillaProduct'

export const brandNameOptions = [
  {
    value: '',
    label: 'Brand Name',
    isDisabled: true,
  },
  { value: "Chi-Chi's", label: "Chi-Chi's" },
  { value: 'Don Pancho', label: 'Don Pancho' },
  { value: 'Early On', label: 'Early On' },
  { value: 'El Comal', label: 'El Comal' },
  { value: 'Essential Everyday', label: 'Essential Everyday' },
  { value: 'Goya', label: 'Goya' },
  { value: 'Great Value', label: 'Great Value' },
  { value: 'Guerrero', label: 'Guerrero' },
  { value: 'Kroger', label: 'Kroger' },
  { value: 'La Banderita', label: 'La Banderita' },
  { value: 'Mission', label: 'Mission' },
  { value: 'Northgate Market', label: 'Northgate Market' },
  { value: 'Ozuna', label: 'Ozuna' },
  { value: "Raley's", label: "Raley's" },
  { value: "Romero's", label: "Romero's" },
  { value: 'Signature Select', label: 'Signature Select' },
  { value: 'Tortilleria Santacruz', label: 'Tortilleria Santacruz' },
  { value: 'Vallarta Supermarkets', label: 'Vallarta Supermarkets' },
]

export const packagingInitialState = {
  category: WheatTortillaProduct.category,
  subCategory: WheatTortillaProduct.subCategory,
  Size: WheatTortillaProduct.Size,
}
